import Vue from 'vue'
import Router from 'vue-router'
//Pages
import Inicio from '@/components/views/Inicio'

import Marcaciones from '@/components/views/Marcaciones'
import MarcacionesDetalle from '@/components/views/MarcacionesDetalle'
//papeletas
import PapeletasSalida from '@/components/views/PapeletasSalida'
import PapeletasVer from '@/components/views/PapeletasVer'
import PapeletasCrear from '@/components/views/PapeletasCrear'
import PapeletasEditar from '@/components/views/PapeletasEditar'
import PapeletasSubir from '@/components/views/PapeletasSubir'

import PapeletasAprobador from '@/components/views/PapeletasAprobador'

import Autorizacion from '@/components/views/Autorizacion'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Inicio
    },
    //Marcaciones
    {
      path : '/marcaciones',
      name: 'Marcaciones',
      component : Marcaciones
    },
    {
      path : '/marcacion',
      name : 'Detalle Marcaciones',
      component : MarcacionesDetalle
    },
    //Autorizacion
    {
      path : '/autorizacion',
      name : 'Autorización',
      component : Autorizacion
    },
    //Papeletas SALIDA
    {
      path : '/papeletas_salida/',
      name : 'Papeletas de Salida',
      component : PapeletasSalida
    },
    {
      path : '/papeletas/aprobar',
      name : 'Aprobar Papeletas',
      component : PapeletasAprobador
    },
    {
      path : '/papeletas/nueva',
      name : 'Crear Papeleta',
      component : PapeletasCrear
    },
    {
      path : '/papeletas/:id',
      name : 'Ver Papeleta',
      component : PapeletasVer
    },
    {
      path : '/papeletas/:id/editar',
      name : 'Editar Papeleta',
      component : PapeletasEditar
    },
    {
      path : '/papeletas/:id/subir',
      name : 'Subir Papeleta',
      component : PapeletasSubir
    },

    /*FIN PAPELETA*/
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js